import React from "react"
import {
    ColorSchemes,
    Box,
    HorizontalStack,
    IconButton,
    Text,
    useColors,
    useTheme,
} from "@mallardbay/lib-react-components"
import { faArrowLeft } from "@fortawesome/free-solid-svg-icons/faArrowLeft"
import { faClockRotateLeft } from "@fortawesome/free-solid-svg-icons/faClockRotateLeft"
import { faXmark } from "@fortawesome/free-solid-svg-icons/faXmark"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"

import AssistantChatContent from "~components/outfitter-assistant/assistant-chat-content"
import AssistantConversationHistory from "~components/outfitter-assistant/assistant-conversation-history"
import { useOutfitterAssistant } from "~contexts/outfitter-assistant-provider"
import { componentStylesCss } from "~utils/helpers/style-helpers"
import COPY from "~config/copy-constants"
import { TEST_IDS } from "~config/constants"
import AssistantTitle from "~components/outfitter-assistant/assistant-title"

export default function AssistantPanelContent() {
    const {
        close,
        view,
        showChat,
        showHistory,
        chat: { messages, error },
    } = useOutfitterAssistant()
    const styles = useStyles()
    const isHistoryView = view === "history"
    const shouldShowSuggestionsContent = !messages.length && !error
    const shouldShowAssistantTitle =
        !isHistoryView && !shouldShowSuggestionsContent
    let titleContent: React.ReactNode = null

    if (isHistoryView) {
        titleContent = (
            <Text style={styles.title}>
                {COPY.OUTFITTER_ASSISTANT_HISTORY_TITLE}
            </Text>
        )
    } else if (shouldShowAssistantTitle) {
        titleContent = <AssistantTitle shouldShowIcon />
    }

    return (
        <>
            <HorizontalStack style={styles.header}>
                {isHistoryView ? (
                    <IconButton
                        testId={TEST_IDS.OUTFITTER_ASSISTANT_HISTORY_BACK}
                        icon={<FontAwesomeIcon icon={faArrowLeft} />}
                        colorScheme={ColorSchemes.Gray}
                        ariaLabel={COPY.OUTFITTER_ASSISTANT_HISTORY_BACK_ARIA}
                        onClick={showChat}
                    />
                ) : (
                    <IconButton
                        testId={TEST_IDS.OUTFITTER_ASSISTANT_HISTORY_BUTTON}
                        icon={<FontAwesomeIcon icon={faClockRotateLeft} />}
                        colorScheme={ColorSchemes.Gray}
                        ariaLabel={COPY.OUTFITTER_ASSISTANT_HISTORY_ARIA}
                        onClick={showHistory}
                    />
                )}
                <Box style={styles.titleSlot}>{titleContent}</Box>
                <IconButton
                    testId={TEST_IDS.OUTFITTER_ASSISTANT_CLOSE}
                    icon={<FontAwesomeIcon icon={faXmark} />}
                    colorScheme={ColorSchemes.Gray}
                    ariaLabel={COPY.OUTFITTER_ASSISTANT_CLOSE_ARIA}
                    onClick={close}
                />
            </HorizontalStack>
            <div style={styles.chatArea}>
                {isHistoryView ? (
                    <AssistantConversationHistory />
                ) : (
                    <AssistantChatContent />
                )}
            </div>
        </>
    )
}

function useStyles() {
    const colors = useColors()
    const theme = useTheme()

    return componentStylesCss({
        header: {
            flexShrink: 0,
            alignItems: "center",
            justifyContent: "space-between",
            padding: `${theme.space[3]} ${theme.space[4]}`,
            borderBottom: `1px solid ${colors.border}`,
        },
        title: {
            fontWeight: theme.fontWeights.semibold,
            fontSize: theme.fontSizes.md,
        },
        titleSlot: {
            flex: 1,
            textAlign: "center",
        },
        chatArea: {
            flex: 1,
            minHeight: 0,
            display: "flex",
            flexDirection: "column",
            overflow: "hidden",
        },
    })
}
